export default __webpack_public_path__ + "static/media/img-0051-usa-full-face.2e370793.png";